import React from 'react';
import Button from '../../../../../components/ComponentsV1/Button';
import { RadioGroup, Textarea } from '../../../../../UiKit';
import { INPUT_MODE, InputModeOptions, inputClassName } from '../constants';

const StepBlock = ({ step, index, onChange, onRemove }) => (
  <div className='tw-w-full tw-box-border tw-border tw-border-solid tw-border-grey-200 tw-rounded-xl tw-flex tw-flex-col tw-overflow-hidden'>
    <div className='tw-flex tw-items-center tw-gap-4 tw-bg-grey-100/60 tw-px-5 tw-py-3 tw-border-0 tw-border-b tw-border-solid tw-border-grey-200'>
      <span className='tw-text-[1.4rem] tw-font-semibold tw-text-grey-800 tw-whitespace-nowrap'>
        Step {index + 1}
      </span>
      <input
        className={`${inputClassName} tw-flex-1 tw-min-w-0`}
        placeholder='Step title (e.g. Product Identification)'
        value={step.title}
        autoComplete='off'
        onChange={(e) => onChange(index, { ...step, title: e.target.value })}
      />
      <div className='tw-shrink-0'>
        <Button
          title='Remove Step'
          type='outline'
          onClick={() => onRemove(index)}
        />
      </div>
    </div>
    <div className='tw-flex tw-flex-col tw-gap-2 tw-p-5'>
      <label className='tw-text-[1.3rem] tw-font-medium tw-text-grey-700'>
        Guideline Content
        <span className='tw-text-grey-400 tw-font-normal'>
          {' '}
          — one guideline per line
        </span>
      </label>
      <Textarea
        value={step.content}
        onChange={(e) => onChange(index, { ...step, content: e.target.value })}
        placeholder='One guideline per line'
        showBtn={false}
        showMaxLimit={false}
        maxLimit={100000}
        height='220px'
      />
    </div>
  </div>
);

const GuidelineBuilder = ({ state, onChange }) => {
  const setMode = (mode) => onChange({ ...state, mode });
  const setDirectText = (directText) => onChange({ ...state, directText });
  const setStep = (idx, next) => {
    const steps = state.steps.slice();
    steps[idx] = next;
    onChange({ ...state, steps });
  };
  const removeStep = (idx) =>
    onChange({ ...state, steps: state.steps.filter((_, i) => i !== idx) });
  const addStep = () =>
    onChange({ ...state, steps: [...state.steps, { title: '', content: '' }] });

  const modeItems = InputModeOptions.map((opt) => ({
    value: opt.value,
    text: opt.label,
    selected: state.mode === opt.value,
  }));

  return (
    <div className='tw-flex tw-flex-col tw-gap-5'>
      <RadioGroup items={modeItems} selectOption={(value) => setMode(value)} />

      {state.mode === INPUT_MODE.DIRECT && (
        <div className='tw-flex tw-flex-col tw-gap-2'>
          <label className='tw-text-[1.4rem] tw-font-medium tw-text-grey-800'>
            Prompt
          </label>
          <Textarea
            value={state.directText}
            onChange={(e) => setDirectText(e.target.value)}
            placeholder='Paste the full prompt here'
            showBtn={false}
            showMaxLimit={false}
            maxLimit={100000}
            height='220px'
          />
        </div>
      )}

      {state.mode === INPUT_MODE.STEP && (
        <div className='tw-flex tw-flex-col tw-gap-4'>
          {state.steps.map((step, idx) => (
            <StepBlock
              key={idx}
              step={step}
              index={idx}
              onChange={setStep}
              onRemove={removeStep}
            />
          ))}
          <div>
            <Button title='Add Another Step' type='secondary' onClick={addStep} />
          </div>
        </div>
      )}
    </div>
  );
};

export default GuidelineBuilder;
